import { useDataManagementContext } from "@/components/ui/data-management/data-management-context";
import { useAppDispatch } from "@/store/store-hooks";
import { setShowSpinner } from "@/store/ui/ui-slice";
import { useNavigateToDraftView } from "@/utils/redirects";
import { FileCheckResult } from "@faro-lotv/data-management";
import { useEffect, useState } from "react";
import {
  DataManagementFileHandlerProps,
  DataManagementFileHandlerReturnType,
} from "./use-data-management-file-handler";

/**
 * @returns Flags and functions to manage the state and behavior of the Data Management picker
 * used by the "Drone data" import card.
 */
export function useDataManagementDroneHandler({
  projectId,
  onClose,
  from,
}: DataManagementFileHandlerProps): Omit<
  DataManagementFileHandlerReturnType,
  "fileTypesByCategory"
> {
  const dispatch = useAppDispatch();
  const navigateToDraftView = useNavigateToDraftView();
  const { setScanFileInfos } = useDataManagementContext();

  const [shouldOpenFileExplorer, setShouldOpenFileExplorer] = useState(false);
  const [isCheckingFiles, setIsCheckingFiles] = useState<boolean>(false);

  function onFinishedCheckingFiles(result: FileCheckResult | null): void {
    dispatch(setShowSpinner(false));

    if (result?.fileInfos?.length) {
      // File infos for the photogrammetry/drone photo upload handled by the Data Management editor.
      setScanFileInfos(result.fileInfos);
      if (projectId) {
        navigateToDraftView(projectId, from);
      }

      if (onClose) {
        onClose();
      }
    }
  }

  // Show a spinner while checking the files.
  useEffect(() => {
    dispatch(setShowSpinner(isCheckingFiles));
  }, [dispatch, isCheckingFiles]);

  return {
    shouldOpenFileExplorer,
    setShouldOpenFileExplorer,
    isCheckingFiles,
    setIsCheckingFiles,
    onFinishedCheckingFiles,
  };
}
